module.exports = __webpack_public_path__ + "img/portrait-062.92f47093.jpg";